/* eslint-disable */
export default {
  createCallLog: 'Create call log',
  viewInSalesforce: 'View in Salesforce',
  createLog: 'Create log',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
